export const getWarningText = ({
  isActionDisabled,
  warning,
  warningIfDisabled,
}: {
  isActionDisabled: boolean;
  warning: string | undefined;
  warningIfDisabled: string | undefined;
}) => {
  return isActionDisabled
    ? warningIfDisabled
    : !isActionDisabled && warning
      ? warning
      : '';
};
